import { HttpLink, split } from '@apollo/client'
import { BatchHttpLink } from '@apollo/client/link/batch-http'

export default function createHttpLink(uri) {
  return split(
    operation => operation.getContext().batch === true,
    new BatchHttpLink({
      uri,
      headers: { batch: 'true' },
      fetchOptions: { mode: 'no-cors' },
    }),
    new HttpLink({ uri }),
  )
}
